var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chart',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"daterangebar",staticClass:"chart el-table--scrollable-x el-table--scrollable-y",attrs:{"option":_vm.option}})}
var staticRenderFns = []

export { render, staticRenderFns }